<template>
  <div class="w-full">
    <div class="card w-full">
      <Tabs
        :value="route.path"
        class="w-full"
      >
        <TabList class="w-full">
          <Tab
            v-for="tab in items"
            :key="tab.label"
            :value="tab.route"
          >
            <router-link
              v-slot="{ href, navigate }"
              :to="tab.route"
              custom
            >
              <a
                v-ripple
                :href="href"
                class="flex items-center gap-2 text-inherit"
                @click="navigate"
              >
                <i :class="tab.icon" />
                <span>{{ tab.label }}</span>
              </a>
            </router-link>
          </Tab>
        </TabList>
      </Tabs>

      <!-- Content slot with full width -->
      <div class="w-full">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

// Define the tab items with icons
const items = ref([
    {
        route: '/workshop/repairs',
        label: 'Repairs',
        icon: 'pi pi-wrench'  // Wrench icon for repairs
    },
    {
        route: '/workshop/loler',
        label: 'LOLER',
        icon: 'pi pi-verified'  // Checkmark/verification icon for testing
    },
    {
        route: '/workshop/pat',
        label: 'PAT Testing',
        icon: 'pi pi-bolt'  // Lightning bolt icon for electrical testing
    },
    {
        route: '/workshop/parts',
        label: 'Parts',
        icon: 'pi pi-box'  // Box icon for parts inventory
    },
    {
        route: '/workshop/consumables',
        label: 'Consumables',
        icon: 'pi pi-shopping-bag'  // Shopping bag icon for consumables
    },
    {
        route: '/workshop/orders',
        label: 'Orders',
        icon: 'pi pi-shopping-cart'  // Shopping cart icon for orders
    }
]);
</script>

<style scoped>
/* Add any custom styling if needed */
.text-inherit {
    color: inherit;
    text-decoration: none;
}

.items-center {
    align-items: center;
}

.flex {
    display: flex;
}

.gap-2 {
    gap: 0.5rem;
}

/* Ensure card takes full width */
.card {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

/* Ensure tab content can be full width */
:deep(.p-tabview-panels) {
    width: 100%;
}
</style>